import React from 'react';
import { Box, Container, Typography, Button, Stack } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
// Update the import path according to your project structure
import CustomSoftIcon from '../../assets/custom_sof_dev.svg';

export const ServiceHero: React.FC = () => (
  <Box
    sx={{
      bgcolor: 'background.paper',
      pt: 12,
      pb: 8,
      borderBottom: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Container maxWidth="lg">
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={4}
        alignItems="center"
        justifyContent="space-between"
      >
        {/* Left Content */}
        <Box flex={1}>
          <Typography 
            component="h1" 
            variant="h2" 
            color="text.primary" 
            gutterBottom
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '2.5rem', md: '3.5rem' }
            }}
          >
            Custom Software Development
          </Typography>
          <Typography 
            variant="h5" 
            color="text.secondary" 
            paragraph 
            sx={{ 
              mb: 4,
              fontSize: { xs: '1.25rem', md: '1.5rem' }
            }}
          >
            End-to-end development services tailored to your needs
          </Typography>
          <Button
            variant="contained"
            size="large"
            endIcon={<ArrowForward />}
            sx={{ 
              textTransform: 'none',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem'
            }}
          >
            Schedule Consultation
          </Button>
        </Box>

        {/* Right Content - Development Visual */}
        <Box
          flex={1}
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            component="img"
            src={CustomSoftIcon}
            alt="Custom Software Development"
            sx={{
              width: '100%',
              maxWidth: 600,
              height: 'auto',
              borderRadius: 2,
              boxShadow: 3,
              bgcolor: 'background.paper'
            }}
          />
        </Box>
      </Stack>
    </Container>
  </Box>
);

export default ServiceHero;